import Vue from "vue";
import moment from "moment";

Vue.filter("formatDate", function(date) {
  return date ? moment(date).format("MMM Do, YYYY") : "";
});
